import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import ToeBoardForm from "./ToeBoardForm";

const CreateToeBoardModalDialogButton: FC = () => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.toeBoards.createNew}>
          <ToeBoardForm onClose={() => setShowNewItemDialog(false)} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateToeBoardModalDialogButton;
